export default __webpack_public_path__ + "static/light_grey-18e1d2b7d3a34be9d05f3344c0b5180d.webp";